"use strict";
// https://www.npmjs.com/package/react-imask
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const imask_1 = __importDefault(require("imask"));
const react_imask_1 = require("react-imask");
const MASK = {
    phone: '+{1} (NNN) NNN-NNNN',
    zip: 'ZZZZZ',
    time: 'HH:MM',
    military: 'HH:MM',
    date: 'MM/DD/YYYY',
    ssn: 'NNN-NN-NNNN',
    ein: 'NN-NNNNNNN',
    currency: 'num',
    integer: 'int',
};
const BLOCKS = {
    phone: {
        R: {
            mask: imask_1.default.MaskedRange,
            from: 2,
            to: 8,
            placeholderChar: '_',
        },
        N: {
            mask: '0',
            placeholderChar: '_',
        },
    },
    zip: {
        Z: {
            mask: '0',
            placeholderChar: '_',
        },
    },
    time: {
        HH: {
            placeholderChar: 'h',
            mask: imask_1.default.MaskedRange,
            from: 1,
            to: 12,
        },
        MM: {
            placeholderChar: 'm',
            mask: imask_1.default.MaskedRange,
            from: 0,
            to: 59,
        },
    },
    military: {
        HH: {
            placeholderChar: 'h',
            mask: imask_1.default.MaskedRange,
            from: 0,
            to: 23,
        },
        MM: {
            placeholderChar: 'm',
            mask: imask_1.default.MaskedRange,
            from: 0,
            to: 59,
        },
    },
    date: {
        DD: {
            placeholderChar: 'D',
            mask: imask_1.default.MaskedRange,
            from: 1,
            to: 31,
        },
        MM: {
            placeholderChar: 'M',
            mask: imask_1.default.MaskedRange,
            from: 1,
            to: 12,
        },
        YYYY: {
            placeholderChar: 'Y',
            mask: imask_1.default.MaskedRange,
            from: 1900,
            to: 2100,
        },
    },
    ssn: {
        N: {
            mask: '0',
            placeholderChar: '_',
        },
    },
    ein: {
        N: {
            mask: '0',
            placeholderChar: '_',
        },
    },
    currency: {
        num: {
            mask: Number,
            thousandsSeparator: ',',
            scale: 2,
            signed: true,
            normalizeZeros: true,
            radix: '.',
            padFractionalZeros: true,
        },
    },
    integer: {
        int: {
            mask: Number,
            thousandsSeparator: ',',
            scale: 0,
            signed: false,
            radix: '.',
        },
    },
};
const withMaskedInput = (Component) => 
// @ts-ignore
(0, react_imask_1.IMaskMixin)((props) => react_1.default.createElement(Component, { ...props }));
const MaskedField = withMaskedInput(index_1.TextField);
const MaskedInput = ({ mask, onChange, value, placeholder, unmask = false, ...rest }) => {
    const isCurrencyMask = mask === 'currency';
    const handleChange = (value) => {
        if (isCurrencyMask) {
            // Raw number value in cents for state (12.34 => 1234)
            onChange(value ? Math.round(Number(value.replace(',', '')) * 100) : undefined);
        }
        else {
            onChange(value);
        }
    };
    const getValue = () => {
        if (isCurrencyMask) {
            // Converted string dollar value to display (1234 => 12.34)
            return value || value === 0 ? String(Number(value) / 100) : undefined;
        }
        else {
            return value;
        }
    };
    const startAdornment = {
        currency: value || value === 0 ? react_1.default.createElement(index_1.InputAdornment, { position: "start" }, "$") : null,
    };
    return (
    // @ts-ignore
    react_1.default.createElement(MaskedField, { "data-testid": `${mask}-masked-input`, mask: MASK[mask], lazy: true, blocks: BLOCKS[mask], radix: ".", 
        // @ts-ignore
        unmask: unmask, 
        // DO NOT USE onChange TO HANDLE CHANGES!
        // USE onAccept INSTEAD
        onAccept: (value) => handleChange(value), 
        // @ts-ignore
        value: getValue(), placeholder: placeholder, InputProps: {
            // @ts-ignore
            startAdornment: startAdornment[mask],
        }, InputLabelProps: { shrink: value ? true : undefined }, ...rest }));
};
exports.default = MaskedInput;
